module.exports = __webpack_public_path__ + "img/3-3.33860f7e.png";